define('presentation/settings/liveReceptionistScripts/presentationObjects/liveReceptionistSchedulePresentationObject',[],function() {
    return function(){
        const self = this;

        self.accountAttendantScheduleId = null;
        self.liveReceptionistScriptId = null;
        self.name = null;
        self.editScheduleUrl = null;
    };
});

